
import { mapState, mapMutations } from "vuex";
import { common, commonApi } from "@/common/index";
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
components: { XDialog, Icon,awesomeSwiper: swiper,swiperSlide },
data() {
return {
list: [],
FloatTopList: [],//首页弹窗数据
swiperOption4: {
autoplay: {
delay: 4000,
disableOnInteraction: false
},
loopedSlides: 1,
loop: true,
pagination: {
el: '.swiper-pagination',
clickable: true
},
},
}
},
computed: {
...mapState({
/*首页弹框 */
homeFloatTopShow: state => state.homeFloatTopShow,
homeFloatTopShow2: state => state.homeFloatTopShow2,
homeFloatTopShow3: state => state.homeFloatTopShow3,
homeFloatTopShow4: state => state.homeFloatTopShow4,
homeFloatTopShow5: state => state.homeFloatTopShow5,
}),
homeFloatTopShowAll() {
return (this.homeFloatTopShow && this.FloatTopList.length > 0) || (this.homeFloatTopShow2 && this.FloatTopList.length > 1) || (this.homeFloatTopShow3 && this.FloatTopList.length > 2) || (this.homeFloatTopShow4 && this.FloatTopList.length > 3) || (this.homeFloatTopShow5 && this.FloatTopList.length > 4)
},
},
created() {
this._initPage()
},
methods: {
...mapMutations(["setHomeFloatTop", "setHomeFloatTop2", "setHomeFloatTop3", "setHomeFloatTop4", "setHomeFloatTop5"]),
_initPage() { // 获取首页弹窗
if (this.homeFloatTopShow) {
if (sessionStorage.getItem('ekgameh5HomeDialog')) {
this.list = JSON.parse(sessionStorage.getItem('ekgameh5HomeDialog'));
this.FloatTopList = this.list;
this.setHomeFloatTop(this.list.length > 0)
} else {
commonApi.HOMEBEFORE.getImgGroup('ekgameh5HomeDialog').then((data) => {
this.list = data;
this.FloatTopList = this.list;
this.setHomeFloatTop(this.list.length > 0)
if (data) {
sessionStorage.setItem("ekgameh5HomeDialog", JSON.stringify(data));
}
})
}
}
},
closeAll() {
this.setHomeFloatTop(false)
this.setHomeFloatTop2(false)
this.setHomeFloatTop3(false)
this.setHomeFloatTop4(false)
this.setHomeFloatTop5(false)
},


handleImg(currentUrl) {
if (currentUrl.length > 0) {
if (currentUrl.indexOf('http') !== -1) {
window.open(currentUrl)
} else {
this.$router.push({ path: currentUrl.replace('#', '') })
}
}
},
_close(index) { // 关闭弹框
if (index == '0') {
this.setHomeFloatTop(false)
} else if (index == '1') {
this.setHomeFloatTop2(false)
} else if (index == '2') {
this.setHomeFloatTop3(false)
} else if (index == '3') {
this.setHomeFloatTop4(false)
} else if (index == '4') {
this.setHomeFloatTop5(false)
}
}
}
}



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/components/home-x-dialog.vue